import moment from 'moment';

// Copyright 2020 Cognite AS
function formatDatetime(time, defaultValue, format) {
    if (defaultValue === void 0) { defaultValue = ''; }
    if (format === void 0) { format = 'MMM D, YYYY HH:mm:ss'; }
    return time ? moment(time).format(format) : defaultValue;
}
function momentFromTimestamp(timestamp) {
    return moment(timestamp);
}
var mapMetaData = function (metaObject) {
    return Object.keys(metaObject).map(function (dp) { return ({
        key: dp,
        name: dp,
        value: metaObject[dp],
    }); });
};

export { momentFromTimestamp as a, formatDatetime as f, mapMetaData as m };
